// extracted by css-extract-rspack-plugin
export default {"betaLabel":"ReposIssuesSidebar-module__betaLabel__FbLDQ","divider":"ReposIssuesSidebar-module__divider__Xkpdx"};